import i18n from "../../../../../i18n";

export const isOn = (value) => [true, "true", "1", 1].includes(value);

export const isCarrierOn = (row) => isOn(row?.is_enable?.user);

// What users read for a carrier. The API spells some names its own way
// ("Fedex", "CanadaPost", "Ics"), so they are looked up by the name in
// lowercase without spaces or punctuation. Any other name shows as the API
// sends it. Display only: payloads keep the API's name.
const DISPLAY_NAMES = {
  canadapost: "Canada Post",
  canpar: "Canpar",
  dayross: "Day & Ross",
  dayandross: "Day & Ross",
  dhl: "DHL",
  fedex: "FedEx",
  gls: "GLS",
  ics: "ICS Courier",
  icscourier: "ICS Courier",
  ups: "UPS",
  xpo: "XPO",
};

export const carrierDisplayName = (name) =>
  (name && DISPLAY_NAMES[String(name).toLowerCase().replace(/[^a-z0-9]/g, "")]) ||
  name;

export const carrierName = (row) =>
  carrierDisplayName(row?.shipping_company_for_user?.name) ?? "-";

export const carrierLogo = (row) => row?.shipping_company_for_user?.logo_url;

export const serviceEntries = (row) => Object.entries(row?.services?.user ?? {});

export const servicesOnCount = (row) =>
  serviceEntries(row).filter(([, value]) => isOn(value)).length;

export const carrierStatusText = (on, onCount, total) => {
  if (!on) return i18n.t("settings:carriers.status.hidden");
  if (!total) return i18n.t("settings:carriers.status.inQuotes");
  return i18n.t("settings:carriers.status.servicesOn", { on: onCount, total });
};

export const formatServiceLabel = (key) =>
  key.replace(/[_-]+/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());

export const carrierInitials = (name) => {
  const words = name.split(/\s+/).filter(Boolean);
  if (words.length > 1) return words.slice(0, 3).map((word) => word[0]).join("").toUpperCase();
  return name.slice(0, 3).toUpperCase();
};
